import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";

export type modeloStyleType = {
  id?: string,
  company?: string,
  name: string;
  colorHeader?: string | null;
  fontHeader?: {
    fontFamily?: string | null;
    fontSize?: number | null;
    color?: string | null;
  };
  background?: string | null;
  fontBackground?: {
    fontFamily?: string | null;
    fontSize?: number | null;
    color?: string | null;
  };
  logo?: string | null;
  associatedChecklists?: string[] | null;
  enablePosMessage?: boolean;
  enablePostMessage?: boolean;
  enableLoop?: boolean;
  enableRedirect?: boolean;
  messageBefore?: string | null;
  imageBefore?: string | null;
  messageAfter?: string | null;
  imageAfter?: string | null;
  link?: string | null
};

class AccessControl {


  getAllFunctionalities = async (
    body: AuthBodyType,
    _empresa?: string,
  ) => {
    try {
      const data: AxiosResponse<string[]> = await api.post("/accessControl/getAllFunctionalities", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  getAllByRole = async (
    body: AuthBodyType,
    roleOrEmpresa: string,
    legacyRole?: string
  ) => {
    try {
      const role = legacyRole || roleOrEmpresa;
      const data: AxiosResponse<string[]> = await api.post("/accessControl/getAllByRole", {
        ...body,
        role
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  changeByRole = async (
    body: AuthBodyType,
    role: string,
    functionalitiesOrEmpresa: string[] | string,
    legacyFunctionalities?: string[]
  ) => {
    try {
      const functionalities = legacyFunctionalities || functionalitiesOrEmpresa as string[];
      const data: AxiosResponse<string[]> = await api.post("/accessControl/changeByRole", {
        ...body,
        role,
        functionalities
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };
}

export default AccessControl;
